import React, { Component } from 'react';
import ScreenContainer from '../ui/ScreenContainer';
import './style.css';
import ControlledExpansionPanels from '../ui/ControlledExpansionPanels';
import Header from '../Header';
import BasicPageComponent from '../BasicPageComponent';
import Button from '../ui/Button';
import styles from './style.js';
import { withStyles } from '@material-ui/core/styles';
import LiNavLink from '../LiNavLink';
import MUTypography from '../ui/MUTypography';
import Avatar from '@material-ui/core/Avatar';
import classNames from 'classnames';
import { history } from '../../App';

const technicalSupportQuestions = [
 {
    id: 'ts1',
    title: 'What is the difference between Instant Money Transfer by IBAN service and other money transfer services under the Money Transfers scope?',
    content: ' The Instant Money Transfer by IBAN API is a single endpoint that can be used for all types of transfers, including EFT, FAST, transfers to Albaraka accounts, and transfers between your own accounts at Albaraka. (endpoint: /moneytransfers/v2/instanttransfer/toiban)'
  },
  {
    id: 'ts2',
    title: 'In which cases is the rule of signing requests valid?',
    content: 'Although the sign rule is not available in the test environment, there is a signing requirement for all APIs in the Production environment.'
  },
  {
    id: 'ts3',
    title: 'Can you give us examples of IBANs that we will use during the testing phase?',
    content: `In the test environment, EFT/FAST transactions can be tested using any valid IBAN. 

Additionally, If money will be transferred to a different account within the same bank-(Havale), you can call the account list API for the customer number from which you want to select the recipient account.`
  },
  {
    id: 'ts4',
    title: 'What does the transferReason field in the request body of Money Transfer services mean and what are the values to be written in this field?',
    content: `For transfers between two Albaraka accounts, values should be in letter format, as shown below: 
Transfer Reason Value – Description 
A – Consumer Arbitration Refund 
B – Interbank Card Center (BKM) Payments 
C – Check Clearing 
D – Other Rent Payments 
E – Education 
H – Treasury Transactions 
I – Workplace Rent Payment 
K – Housing Rent 
L – Credit Card Debt 
M – Salary Payment 
P – Employee Payments 
S – E-commerce Payments 
T – Dues 
V – Vostro Transactions 

For EFT/FAST transfers to accounts at other banks, values should be in numeric format, as shown below: 

Transfer Reason Value- Description 
01 – Housing Rent Payment 
02 – Workplace Rent Payment 
03 – Other Rent Payment 
04 – E-commerce Payment 
05 – Employee Payment 
06 – Commercial Payment 
07 – Personal Payment 
08 – Investment Payment 
09 – Financial Payment 
10 – Education Payment 
11 – Dues Payment 

 The value -2 is valid for all cases. 

You can leave the transfer reason field blank for internal (virman) transfers.`
  },
  {
    id: 'ts5',
    title: 'How can we inquire about the status of transactions made using the Money Transfer service?',
 content : `You can make a query with the Transfer Status service under the Money Transfers heading. Relevant endpoint:

/moneytransfers/v2/transfer/status endpoint. After making the money transfer, you need to send a request by adding the transfer date value and the "refereceNumber" value in the money transfer response to the body of the transfer status API.

You can learn the status of the money transfer from here.


An example flow:

{
  "data": {
    "accountingResponse": {
      "LogBranchCode": 0,
      "LogDate": "string",
      "ReferenceNumber": 0
    },
    "errorCode": 0,
    "message": "İsleminiz basari ile gerceklesmistir.",
    "refereceNumber": "000017",
    "responseType": 0,
    "responseTypeDesc": "STANDARD",
    "transactionDate": "2018-11-02"
  },
  "header": {
    "detailCode": "string",
    "message": "string",
    "status": "FAILURE",
    "statusCode": 0,
    "txId": "string",
    "warnings": [
      {
        "key": "string",
        "text": "string"
      }
    ]
  }
}

As above, the referenceNumber and transactionDate values from the Transfer response should be taken and added to the Transfer Status body.

An example Transfer Status body is as follows:

{
  "context": {
    "language": "ar"
  },
  "isInternalTransfer": false,
  "referenceNumber": 000017,
  "transactionDate": "01.24.2018"
}

The status values that will return in response are as follows:

REALIZED ("01"), SENT ("02"), NOT REALIZED ("03"), WAITING FOR APPROVAL ("04"), PROCESSED ("05")`

  },
  {
    id: 'ts6',
    title: 'Which money transfer services should we use for sub-accounts (Sanal IBAN)?',
    content: `When transferring money, the service does not differ according to the sub-accounts. You can use the services under the title Money Transfer at https://developer.albarakaturk.com.tr/docs . We recommend that you use the Instant Money Transfer by IBAN service for money transfer. 

You only need to change the suffix section in the request for each sub-account. You can access the suffix of each sub-account from the request that comes when you call the account list service. `
  },
  {
    id: 'ts7',
    title: 'What is your webhook system and what does it do?',
    content: `Webhook is a system that notifies you instantly when there is a change in an account belonging to you. When you use this service, you will receive an instant notification when money is transferred into or out of your accounts. You can use the Webhook service free of charge.`
  },
  {
    id: 'ts8',
    title: 'Can you give information about the process of starting to use webhooks?',
    content: `You will receive a webhook for each amount that comes to your account. In order to use the webhook service, you need to provide a test and prod environment URL where our systems can trigger your systems. We will complete the necessary registration processes in the system for the URLs you provide. 

In addition to these, you need to create a test application for the webhook at Albaraka Api Market (Albaraka Api Market). You can find the steps for creating an application under the getting started heading on the api portal (https://developer.albarakaturk.com.tr/gettingStarted ). In the test environment you create, you will automatically be assigned a client id and client secret values. You need to provide us with your client id value. After you share the client information, our technical team will complete the webhook definition in the test environment for your client, such that one of the customers in the test environment will be your customer. 

Afterwards, for the transaction types you want to receive webhook notifications for, you need to call the save webhook service under the webhooks scope in the developer portal (https://developer.albarakaturk.com.tr/docs ) and create a record for the transactions you want. You can make a service call by giving the transaction type you want to receive notifications for in the trancode field in the request of the relevant service. The transaction types are as follows; 

CHVLH // Incoming Remittance from Albaraka Accounts 

CVIRM // Incoming Remittance  from Your Own Albaraka Accounts 

EEFTO // Incoming EFT 

FBTCH // Incoming Fast 

 

After you complete the relevant steps, when there is any movement towards the accounts of the customer defined as your customer in the test environment for the relevant transaction types, the webhook/notification will come to the test url you shared with us. 

After completing the testing process, the live environment integration will proceed in a similar manner. `
  },
  {
    id: 'ts9',
    title: 'How often does it take for the money accumulated in sub-accounts to be swept into the main account?',
    content: `At least every hour, the money accumulated in sub-accounts can be swept into the main account.`
  }

];


const generalQuestions = [
  {
    id: 'g1',
    title: 'What is the difference between V1 and V2 versions of service endpoints and which endpoints are recommended to be used?',
    content: `We always recommend using the current version. If there are v1 and v2 versions in the relevant service, the current version is v2.`

  },
  {
    id: 'g2',
    title: 'What is the link to access the test environment?',
    content: `In order to access the test environment, you must become a member of our portal at https://developer.albarakaturk.com.tr/register . 

After becoming a member and logging into the site, you can create a new application on the Dashboard page and send a request. 

The initial steps are explained step by step on the portal under the https://developer.albarakaturk.com.tr/gettingStarted page. After creating an application, you can access detailed information about receiving tokens and sending requests to APIs from the https://developer.albarakaturk.com.tr/docs page. `
  },

  {
    id: 'g3',
    title: 'What is the Albaraka Turk API Portal?',
    content: `Albaraka Turk API Portal is a comprehensive digital platform that enables developers creating innovative applications to explore and effectively utilize the rich in content and useful Albaraka API Inventory. 

This platform provides developers with easy access to the resources they need through its user-friendly interface and extensive documentation, supporting them in bringing their creative projects to life. The Albaraka API Market also fosters an environment that encourages community interaction, allowing developers to share ideas and collaborate. This creates opportunities for both individual and corporate-level innovative solutions. 

 

Through Albaraka APIs, developers can unleash their potential in various fields, including financial services, data management, and application integration. The Albaraka API Market facilitates this process, enabling users to deliver digital solutions more quickly and effectively. `
  },

  {
    id: 'g4',
    title: 'How can I contact you for general and technical questions?',
    content: `There are multiple ways to reach us. You can write to us via the contact form or you can create a support ticket on our Support page. You can also join our Slack channel to ask questions to both us and other developers in the ecosystem. Additionally, you can email us directly at: albarakaapi@albarakaturk.com.tr`
  },

  {
    id: 'g5',
    title: 'How to go Live?',
    content: `To use the Albaraka APIs in the live environment, you must fill out and sign a contract and a request form. After that, we perform certain authorization procedures, and then you can send requests in the live environment free of charge. For live environment authorization, you can email us directly at albarakaapi@albarakaturk.com.tr`
  }
];

const applicationQuestions = [
  {
    id: 'a1',
    title: 'What is an application?',
    content: `An application is designed to manage a user's API credentials. When you create an application, it generates a unique client_id and client_secret value. You will use these values during the authorization step to access our APIs.`
  },
  {
    id: 'a2',
    title: 'How to create an application?',
    content: `After registering and logging in to the Albaraka API Market, you will be automatically redirected to the Dashboard page, where you can create a new application from the New Applications tab. To learn more about registering for the Albaraka API Market and creating an application, you can read the following content on our blog page:  

* https://medium.com/albaraka-open-banking/registering-on-albaraka-api-market-and-creating-a-test-application-305a6a303cc1 (EN) 

* https://medium.com/albaraka-open-banking/albaraka-api-markete-%C3%BCye-olma-ve-test-uygulamas%C4%B1-olu%C5%9Fturma-26d4dc924027 (TR) `
  },
  {
    id: 'a3',
    title: 'How many applications can I create?',
    content: `There is no limit for the number of applications you create.`
  }
];

const loginRegisterQuestions  = [
  {
    id: 'lr1',
    title: 'How do I register?',
    content: `For registiration, click Register or Sign Up button from the home page. Enter your name, your lastname, your email, your password and choose your country. Click the Register Now button. Activation link sent to your email to activate your account. You’ll be ready for developing after click activation link.`
  },
  {
    id: 'lr2',
    title: 'How do I Login?',
    content: `Click on the Log in button at the top right of the page. After typing your e-mail and password, you will be directed to “Dashboard” page. `
  },
  {
    id: 'lr3',
    title: 'What are the password requirements?',
    content: `Your password should consist of at least 8 characters and at least one uppercase letter, one lowercase letter, one number, and one special character.`
  }
];

class Faq extends Component {

  constructor(props) {
    super(props);
    this.state = {
      generalQuestions:[],
      technicalSupportQuestions: [],
      applicationQuestions: [],
      loginRegisterQuestions: [],
      isGeneralClicked: false,
      isBankingClicked: true,
      isSupportClicked: false,
      isLoginClicked: false,
      isApplicationClicked: false
    };
  }
  handleGeneralClick = () => {
    this.setState({
      isGeneralClicked: true,
      isBankingClicked: false,
      isSupportClicked: false,
      isLoginClicked: false,
      isApplicationClicked: false
    });
  };
  handleBankingClick = () => {
    this.setState({
      isGeneralClicked: false,
      isBankingClicked: true,
      isSupportClicked: false,
      isLoginClicked: false,
      isApplicationClicked: false,
    });
  };
  handleSupportClick = () => {
    this.setState({
      isGeneralClicked: false,
      isBankingClicked: false,
      isSupportClicked: true,
      isLoginClicked: false,
      isApplicationClicked: false,
    });
  };
  handleLoginClick = () => {
    this.setState({
      isGeneralClicked: false,
      isBankingClicked: false,
      isSupportClicked: false,
      isLoginClicked: true,
      isApplicationClicked: false,
    });
  };
  handleApplicationClick = () => {
    this.setState({
      isGeneralClicked: false,
      isBankingClicked: false,
      isSupportClicked: false,
      isLoginClicked: false,
      isApplicationClicked: true,
    });
  };
  handleButtonSlackClick = () => {
    const url = 'https://join.slack.com/t/albarakaapi/shared_invite/zt-24pex8dlv-htHYqVb4SdZkM9~DI1fPWQ';
    window.open(url, '_blank');
  };
  handleButtonMediumClick = () => {
    const url = 'https://medium.com/albaraka-open-banking';
    window.open(url, '_blank');
  };
  componentWillMount() {
    // TODO: get faqs from service
    window.scrollTo(0, 0);
    this.setState({

      technicalSupportQuestions: technicalSupportQuestions.slice(0, 9),
      generalQuestions : generalQuestions.slice(0, 5),
      applicationQuestions : applicationQuestions. slice(0, 3),
      loginRegisterQuestions: loginRegisterQuestions.slice(0, 3)

    });
  }

  onClick = (e, name, value) => {
    e.preventDefault();
    this.setState({ [name]: [...value] });
  };

render() {
    const { classes } = this.props;
    const { generalQuestions, applicationQuestions , technicalSupportQuestions, loginRegisterQuestions } = this.state;

    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column'
      }}>
        <Header />
        <div>
          <MUTypography className={classes.containerTitle}>
            FAQ
          </MUTypography>
          <MUTypography className={classes.containerTypography}>
            You can find frequently asked questions and their answers in the FAQ section, which includes previously asked and likely questions.
          </MUTypography>
          <div style={{ display: 'flex', margin: 'auto', justifyContent: 'center', textAlign: 'center' }}>
            <ul style={{ listStyleType: 'none', display: 'flex', margin: 'auto', justifyContent: 'center', textAlign: 'center', color: '#8B96A4' }}>
              <Button
                variant='text'
                text="TECHNICAL SUPPORT"
                className={this.state.isGeneralClicked ? classes.underline : classes.header}
                onClick={this.handleGeneralClick}
              />
              <Button
                variant='text'
                text="GENERAL"
                className={this.state.isBankingClicked ? classes.underline : classes.header}
                onClick={this.handleBankingClick} />
              <Button
                variant='text'
                text="APPLICATIONS"
                className={this.state.isApplicationClicked ? classes.underline : classes.header}
                onClick={this.handleApplicationClick}
              />
              <Button
                variant='text'
                text="LOGIN AND REGISTER"
                className={this.state.isLoginClicked ? classes.underline : classes.header}
                onClick={this.handleLoginClick}
              />

            </ul>
          </div>
          <div hidden={!this.state.isGeneralClicked} className={classes.controlledExpansionPanels}>
            <ControlledExpansionPanels questions={technicalSupportQuestions} />
          </div>
          <div hidden={!this.state.isBankingClicked} className={classes.controlledExpansionPanels}>
            <ControlledExpansionPanels questions={generalQuestions} />
          </div>
          <div hidden={!this.state.isApplicationClicked} className={classes.controlledExpansionPanels}>
            <ControlledExpansionPanels questions={applicationQuestions} />
          </div>
          <div hidden={!this.state.isLoginClicked} className={classes.controlledExpansionPanels}>
            <ControlledExpansionPanels questions={loginRegisterQuestions} />
          </div>

          </div>
          <div style={{ margin: 'auto', textAlign: 'center' }}>
            <Button
              variant='text'
              classes={{ root: classes.getStartBtn }}
              text="STILL NEED HELP?"
              onClick={() => { history.push("/support") }}

            >
            </Button>
          </div>
          <div style={{ textAlign: 'center', margin: 'auto' }}>
            <div style={{ display: 'flex', maxWidth: '75%', paddingBottom: 56, margin: 'auto', justifyContent: 'center' }}>
              <div >
                <img style={{ position: 'absolute', zIndex: 1, marginTop: 25, marginLeft: 25 }} src={require('../../images/slackBlack.png')} alt="community" />
                <Button
                  variant='text'
                  classes={{ root: classes.letsStartBtn, label: classes.getStartBtnTxt }}
                  text="JOIN OUR COMMUNITY"
                  onClick={this.handleButtonSlackClick}
                />
              </div>
              <div>
                <img style={{ position: 'absolute', zIndex: 1, marginTop: 25, marginLeft: 25 }} src={require('../../images/mediumBlack.png')} alt="community" />

                <Button
                  variant='text'
                  classes={{ root: classes.letsStartBtn, label: classes.getStartBtnTxt }}
                  text="Our Medium Blog"
                  onClick={this.handleButtonMediumClick}
                />
              </div>
            </div>
          </div>
        </div>
    );
  }
}

export default withStyles(styles)(Faq);
